export default "__VITE_ASSET__DrtIjD14__"